function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { getSpotlightStyles, titleFontSizesBOH } from '../../helpers/utils';
import { Textfit } from 'react-textfit';
const HeaderLeaderboard = ({
  text,
  metadata,
  description
}) => {
  const {
    body_color,
    titleStyle,
    title_font_family
  } = getSpotlightStyles(metadata, text);
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: titleStyle
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.large
  }, text.title)), /*#__PURE__*/React.createElement("p", {
    style: {
      color: body_color
    },
    className: "description"
  }, description));
};
const HeaderNonLeaderboard = ({
  text,
  metadata,
  group_name,
  showUpdatedTime
}) => {
  const {
    logo
  } = metadata;
  const {
    body_color,
    titleStyle,
    title_font_family
  } = getSpotlightStyles(metadata, text);
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: titleStyle
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.medium
  }, text.title)), showUpdatedTime && /*#__PURE__*/React.createElement("p", {
    className: "updated-time",
    style: {
      color: body_color
    }
  }, group_name ? `By ${group_name} sales today,  updated ` : 'Updated ', "right now")));
};
const Header = props => props.isLeaderboard ? /*#__PURE__*/React.createElement(HeaderLeaderboard, _extends({
  props: true
}, props)) : /*#__PURE__*/React.createElement(HeaderNonLeaderboard, _extends({
  props: true
}, props));
export default Header;